"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valuesOf = exports.wrapInAsyncAction = void 0;
const lodash_1 = require("lodash");
function wrapInAsyncAction(onSubmit) {
    return ((form) => Promise.resolve(onSubmit(form)));
}
exports.wrapInAsyncAction = wrapInAsyncAction;
function valuesOf(fields) {
    return (0, lodash_1.mapValues)(fields, field => field.value);
}
exports.valuesOf = valuesOf;
